import React from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { useGlobalData } from "@src/hooks/useEnhancedBlockSettings";
import BreadcrumbsContainer from "./BreadcrumbsContainer";
import getBreadcrumbsByTemplate from "./getBreadcrumbsByTemplate";
import BreadcrumbItem from "./BreadcrumbItem";
import BreadcrumbIcon from "./BreadcrumbIcon";
import "./Breadcrumbs.scss";

export const Breadcrumbs = ({ settings, ...props }) => {
  const globalData = useGlobalData(props);
  const { template, routes } = globalData;
  const isMobile = useMobileBreakpoint(1024); // Use fixed breakpoint to avoid instability
  console.log('Breadcrumbs render:', { settings, globalData, templateName: template?.name });
  const templateName = template?.name;
  const backToCategory = settings?.use_back_to_category_products;

  // Create a combined settings object for backward compatibility with getBreadcrumbsByTemplate
  const combinedSettings = {
    ...settings,
    ...globalData,
    section: settings // section settings are now part of block settings
  };

  // Create settings format expected by child components
  const childSettings = { section: settings };

  return (
      <BreadcrumbsContainer isMobile={isMobile} settings={childSettings as any}>
        {!backToCategory && (
          <BreadcrumbItem 
            title="Home" 
            url={routes?.root_url || "/"} 
            position={1} 
            settings={childSettings as any} 
            isMobile={isMobile} 
            classes="" 
          />
        )}
        {(templateName !== "index" && !backToCategory) && (
          <BreadcrumbIcon 
            settings={childSettings as any} 
            isMobile={isMobile} 
            icon={settings.icon || "icon-caret-right-thin"} 
          />
        )}
        {getBreadcrumbsByTemplate(templateName, combinedSettings, isMobile)}
      </BreadcrumbsContainer>
  );
};
